import { useSetState, useForm } from '@domain-group/react-hooks'

import api from '@functions/api'
import { handleError } from '@redux/utils'

import { isValidEmail } from '@domain-group/javascript-utils'

import defaultRequestOptions from '@sections/Admin/packs/SystemManager/defaultRequestOptions'

const editUser = (editUserUrl) => {
  window.location.href = editUserUrl || null
}

const findAgentUsingDetails = (params, setState) => {
  setState({ searching: true })

  const promise = api('/agents/find_agent_with_details.json', { ...defaultRequestOptions.agent, ...params })
    .then(({ data }) => {
      setState({
        agent: data, hasResult: true, searching: false, searchComplete: true,
      })
    })
    .catch((data) => {
      const errors = handleError(data)

      setState({ hasResult: false, searching: false, searchComplete: true })
      return { success: false, result: errors }
    })

  return promise
}

const defaultState = {
  agency_id: null,
  email: '',
  mobile: '',
  name: '',
}

const requiredFields = [
  { key: 'agency_id' },
  { key: 'email', validation: isValidEmail, invalidMessage: 'Invalid Email format' },
  { key: 'mobile' },
]

const searchState = {
  agent: {},
  hasResult: false,
  searchComplete: false,
  searching: false,
}

const useFindAgent = () => {
  const [state, setState] = useSetState(searchState)
  const {
    agent, hasResult, searching, searchComplete,
  } = state

  const agentFormPayload = useForm(defaultState, { requiredFields, validateOn: 'change' }, [])

  return {
    agent,
    agentFormPayload,
    callbacks: {
      findAgent: params => findAgentUsingDetails(params, setState),
      editUser,
    },
    hasResult,
    searching,
    searchComplete,
  }
}

export default useFindAgent
